import Checkbox from 'components/shared/Checkbox/Checkbox';

const TableGfeActions = ({ statusGroup, onCheckedChange, checked, isPast = false }) => {
  const handleCheckedChange = (e) => {
    const isCheckedValue = e.target.checked;
    onCheckedChange(statusGroup.statusName, isCheckedValue, isPast);
  };

  return <Checkbox isChecked={checked} onChange={handleCheckedChange} size={16} />;
};

export default TableGfeActions;
